import React from 'react'
import './register.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import './register.css'
// import Zip from 'react-zipcode'
// import DropdownMenu from 'react-bootstrap/DropdownMenu'
// import DropdownItem from 'react-bootstrap/DropdownItem'
import axios from 'axios'
import { noConflict } from 'q';
import * as urls from '../../urls';

class StoreRegister extends React.Component {

    constructor(props) {
      super(props);

      if(props.history.location.state === undefined) {
        props.history.push("/register/")
      }
      var jwt = props.history.location.state.jwt;

      if(jwt === undefined) {
          props.history.push("/register/");
      }
      this.state = {
            // fname: prevState.fname,
            // lname: prevState.lname,
            // email: prevState.email,
            // pass: prevState.password,
            // phone: prevState.phone,
            storename: null,
            storephone: null,
            address: null,
            city: null,
            state: null,
            zip: null,
            logo: null,
            jwt: 'Bearer ' + props.history.location.state.jwt,
        };
  
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeFile = this.handleChangeFile.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = (event) => {
        event.preventDefault()
        this.setState({[event.target.name]: event.target.value});
    }

    handleChangeFile = (event) => {
        event.preventDefault()
        this.setState({logo: event.target.files[0]});
    }
  
    handleSubmit = (event) => {
        event.preventDefault();
        const data = this.state;

        const entries = Object.entries(data);
        for(const [, value] of entries) {
            if(value === null || value === '' || value === undefined) {
                alert("All fields are required");
                return;
            }
        }

        var bodyFormData = new FormData();
        bodyFormData.append('location_name', data.storename);
        bodyFormData.append('location_phone', data.storephone);
        bodyFormData.append('location_address', data.address);
        bodyFormData.append('location_city', data.city);
        bodyFormData.append('location_state', data.state);
        bodyFormData.append('location_zip', data.zip);
        bodyFormData.append('location_logo', data.logo);

        var body = {'location_name': data.storename, 'location_phone': data.storephone,
                    'location_address': data.address, 'location_city': data.city,
                    'location_state': data.state, 'locaiton_zip': data.zip, 'location_logo': data.logo}
        
        axios({
            method: 'post', 
            url: urls.registerStore,
            data: body,
            withCredentials: true,
            headers: {'content-type': 'application/json', 'Authorization': data.jwt}
        })
        .then((response) => {
            console.log(response.data);
            this.props.history.push({pathname: "/store-register/"});
        })
        .catch(function (error) {
            console.log(error);
        });
    }
  
    render() {
      return (
        <div className="register-container">
            <div className="container">
                <div className="row">
                <div className="col-sm-9 col-md-7 col-lg-5 mx-auto" style={{marginTop: `-420px`}}>
                    <div className="card card-signin my-5">
                        { this.props.history.location.state.fromLogin === true && 
                            <div class="alert alert-warning" role="alert">
                                You must complete your store registration.
                            </div>
                        }
                        <div className="card-body">
                            <h5 className="card-title text-center">Store Information</h5>
                                <form className="form-signin" onSubmit={ this.handleSubmit }>
                                    <div className="form-group">
                                    
                                        <div className="form-label-group">
                                            <input className="form-control" id="storename" type="text" value={this.state.value} 
                                                onChange={this.handleChange} placeholder="Store Name" name="storename" />
                                            <label for="storename">Store Name</label>
                                        </div>

                                        <div className="form-label-group">
                                            <input className="form-control" id="storephone" type="tel" value={this.state.value}
                                                onChange={this.handleChange} placeholder="Store Phone Number" name="storephone" pattern="[0-9{3}-[0-9]{3}-[0-9]{4}"/>
                                            <label for="storephone">Store Phone</label>
                                        </div>

                                        <div className="form-label-group">
                                            <input className="form-control" id="address" type="text" value={this.state.value} 
                                                onChange={this.handleChange} placeholder="Street Address" name="address" />
                                            <label for="address">Street Address</label>
                                        </div>

                                        <div className="form-label-group">
                                            <input className="form-control" id="city" type="text" value={this.state.value} 
                                                onChange={this.handleChange} placeholder="City" name="city" />
                                            <label for="city">City</label>
                                        </div>

                                        <div className="form-label-group">
                                            <select className="form-control custom-select" id="state" name="state" value={ this.state.value } onChange={ this.handleChange }><option value="State">State</option><option value="Alabama">Alabama</option><option value="Alaska">Alaska</option><option value="Arizona">Arizona</option><option value="Arkansas">Arkansas</option><option value="California">California</option><option value="Colorado">Colorado</option><option value="Connecticut">Connecticut</option><option value="Delaware">Delaware</option><option value="District of Columbia">District of Columbia</option><option value="Florida">Florida</option><option value="Georgia">Georgia</option><option value="Guam">Guam</option><option value="Hawaii">Hawaii</option><option value="Idaho">Idaho</option><option value="Illinois">Illinois</option><option value="Indiana">Indiana</option><option value="Iowa">Iowa</option><option value="Kansas">Kansas</option><option value="Kentucky">Kentucky</option><option value="Louisiana">Louisiana</option><option value="Maine">Maine</option><option value="Maryland">Maryland</option><option value="Massachusetts">Massachusetts</option><option value="Michigan">Michigan</option><option value="Minnesota">Minnesota</option><option value="Mississippi">Mississippi</option><option value="Missouri">Missouri</option><option value="Montana">Montana</option><option value="Nebraska">Nebraska</option><option value="Nevada">Nevada</option><option value="New Hampshire">New Hampshire</option><option value="New Jersey">New Jersey</option><option value="New Mexico">New Mexico</option><option value="New York">New York</option><option value="North Carolina">North Carolina</option><option value="North Dakota">North Dakota</option><option value="Northern Marianas Islands">Northern Marianas Islands</option><option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option><option value="Oregon">Oregon</option><option value="Pennsylvania">Pennsylvania</option><option value="Puerto Rico">Puerto Rico</option><option value="Rhode Island">Rhode Island</option><option value="South Carolina">South Carolina</option><option value="South Dakota">South Dakota</option><option value="Tennessee">Tennessee</option><option value="Texas">Texas</option><option value="Utah">Utah</option><option value="Vermont">Vermont</option><option value="Virginia">Virginia</option><option value="Virgin Islands">Virgin Islands</option><option value="Washington">Washington</option><option value="West Virginia">West Virginia</option><option value="Wisconsin">Wisconsin</option><option value="Wyoming">Wyoming</option></select>
                                        </div>

                                        <div className="form-label-group">
                                            <input className="form-control" id="zip" type="text" value={this.state.value} 
                                                onChange={this.handleChange} placeholder="Postal Code" name="zip" />
                                            <label for="zip">Postal Code</label>
                                        </div>

                                        <div className="form-label-group">
                                            <input className="form-control" id="logo" type="file" multiple={ false } ref={(input) =>{ this.inputElement = input; }} accept=".jpg, .jpeg, .png" 
                                                onChange={this.handleChangeFile} placeholder="Store Logo" name="logo" />
                                            <label for="logo">Store Logo</label>
                                        </div>
                                        <button className="btn btn-lg btn-primary btn-block btn_red text-uppercase" type="submit">Finish</button>
                                        
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        
      );
    }
  }

  export default StoreRegister